import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import Layout from "../../components/Layout";
import { useTranslation } from "react-i18next";
import SurveyContent from "../../components/Pages/Survey";

const { displayName } = config;

export default function Survey() {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = `${displayName}: Survey`;
  }, []);

  return (
    <Layout title="Survey">
      <SurveyContent />
    </Layout>
  );
}
